module.exports = __webpack_public_path__ + "9da45cb9586abe69b3d89ccd67973653.glb";